import React, { useMemo } from 'react';
import SourceIcon from "@components/sources/SourceIcon.component";
import { Analysis } from '@models/analysis';

interface AnalysisSourcesProps {
  analysis: Analysis;
  label?: string;
  className?: string;
}

const AnalysisSources: React.FC<AnalysisSourcesProps> = ({
  analysis,
  label = "This data comes from",
  className = ""
}) => {
  const sourceIds = useMemo(() => {
    if (analysis.uses_source_ids && analysis.uses_source_ids.length > 0) {
      return analysis.uses_source_ids;
    }
    return [];
  }, [analysis.uses_source_ids]);

  if (!sourceIds.length) {
    return null;
  }

  return (
    <div className={`d-flex align-items-center ${className}`}>
      <p className="mb-0 d-flex align-items-center">
        <span>{label}</span>
        {sourceIds.map((sourceId, index) => (
          <SourceIcon 
            key={index} 
            sourceId={sourceId} 
            compact={true} 
            className="ms-1" 
            showTitle={true} 
          />
        ))}
      </p>
    </div>
  );
};

export default AnalysisSources;